import { Autocomplete, Checkbox, FormGroup, TextField } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import {
  getDeliveryInfoListAsync,
  selectedDeliverySlot,
  selectedDeliveryType,
  setPayButtonDisabled,
  setStepperActiveMenu,
  selectedDeliveryDate,
} from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import CustomButton from "../../../../../components/custom/button";
import CustomInput from "../../../../../components/custom/input";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import NearMeIcon from "@mui/icons-material/NearMe";
import AddIcon from "@mui/icons-material/Add";
import { getAddressListAsync } from "../../../../../../app/slices/addressSlice/ProfileSlice";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
export const DeliveryInfo = () => {
  const dispatch = useAppDispatch();
  const [slotValue, setSlotValue] = useState<{ id: string; value: string }>({
    id: "",
    value: "",
  });
  const [selectedDate, setSelectedDate] = useState<any>("");
  useEffect(() => {
    dispatch(getAddressListAsync());
  }, []);
  useEffect(() => {
    dispatch(selectedDeliveryType("delivery"));
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [selectedType, setSelectedType] = useState("delivery");
  const [isVisible, setIsVisible] = useState(false);
  const selectedAddressId = useAppSelector(
    (state) => state.CheckoutState.selectedAddressId
  );
  const { profileData }: any = useAppSelector((state) => state.ProfileState);

  const { addressList }: any = useAppSelector((state) => state?.AddressState);
  useEffect(() => {
    if (addressList?.data?.length > 0 && selectedAddressId) {
      const addr = addressList.data.filter(
        (item: any) => item.id === selectedAddressId
      )[0];

      if (addr) {
        setDeliveryAddress(`${addr.flat_no + " " + addr.landmark}`);
      }
    }
  }, [selectedAddressId, addressList]);

  const deliveryInfoOptions = useAppSelector(
    (state) => state.CheckoutState.deliveryinfoList
  );

  const onNextClick = (active: any) => {
    dispatch(setStepperActiveMenu(active));
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const isInputFilled =
    (slotValue?.value?.trim() !== "" && deliveryAddress.trim() !== "") ||
    selectedType === "pickup";
  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const { name, value } = event.target;
    setDeliveryAddress(event.target.value);
    // setDeliveryAddress(event.target);
    // let curErrors: any = { ...errors };
    // delete curErrors[name];
    // setErrors(curErrors);
    // setLoginData({
    //   ...loginData,
    //   [name]: value,
    // });
  };
  useEffect(() => {
    dispatch(setPayButtonDisabled(!isInputFilled));
  }, [isInputFilled, dispatch]);
  useEffect(() => {
    dispatch(getDeliveryInfoListAsync());
  }, []);
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSelectedType(value);
    dispatch(selectedDeliveryType(value));
  };
  const handleDateChange = (newDate: Dayjs | null) => {
    const formattedDate = newDate ? newDate.format("YYYY-MM-DD") : null;
    setSelectedDate(formattedDate);
    dispatch(selectedDeliveryDate(formattedDate));
  };

  const handleRedirectToMap = (latitude: any, longitude: any) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    // window.location.href = googleMapsUrl; // This will open the Google Maps URL
    window.open(googleMapsUrl, "_blank");
  };
  return (
    <div>
      <h2>Delivery Info</h2>
      <div className="mt-4 w-70">
        {deliveryInfoOptions?.pickup && (
          <FormControl required>
            {/* Optional: FormLabel>
          {/* <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel> */}
            <RadioGroup
              onChange={handleRadioChange}
              row
              value={selectedType}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="delivery"
                control={<Radio />}
                label="Home Delivery"
              />
              <FormControlLabel
                value="pickup"
                control={<Radio />}
                label="Shop Pickup"
              />
            </RadioGroup>
          </FormControl>
        )}

        {selectedType === "pickup" && (
          <div id="Deliverybakery3" className="desc">
            <p className="mb-3 orange-txt">
              Please contact the pickup point before arrival
            </p>
            <div>
              <div className="tf-field style-1 mb_15">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={dayjs()}
                    maxDate={dayjs().add(2, "day")}
                    format="DD-MM-YYYY"
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(newDate) => handleDateChange(newDate)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        placeholder: "Select your pickup date",
                        inputProps: {
                          placeholder: "Select your pickup date",
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div>
              <fieldset className="box fieldset">
                <span>Phone No.</span>
                <div style={{ paddingTop: "1rem" }}>
                  <CustomInput
                    type="text"
                    label="Phone Number"
                    name="phone_number"
                    required
                    size="small"
                    variant="outlined"
                    fullWidth
                    rows={3}
                    value={profileData?.data?.phone_number}
                    readOnly
                    // onChange={inputChange} // Handle address input change
                  />
                  {/* <TextField type="text" value="+91 1234567890"></TextField> */}
                </div>
              </fieldset>
            </div>

            <p className="orange-txt" style={{ paddingTop: "1rem" }}>
              <b>Contact Details</b>
            </p>

            <p>
              {deliveryInfoOptions?.shopDetails?.shop_name}
              <br />
              {deliveryInfoOptions?.shopDetails?.shop_location}
              {/* <br />
              Ernakulam, Kerala 682021 */}
              <br />
              Phone No.: {deliveryInfoOptions?.shopDetails?.shop_phone}
            </p>

            <p className="mt-3">
              <a href="#" className="orange-txt">
                <b>
                  <i className="fa fa-location-arrow"></i>
                  <span
                    style={{ paddingLeft: "7px" }}
                    onClick={() =>
                      handleRedirectToMap(
                        deliveryInfoOptions?.shopDetails?.latitude,
                        deliveryInfoOptions?.shopDetails?.longitude
                      )
                    }
                  >
                    Pickup point Location Map
                  </span>
                </b>
              </a>
            </p>
          </div>
        )}
      </div>
      <div className="mt-4 w-70">
        {selectedType !== "pickup" && (
          <div className="desc">
            {/* Estimated Delivery Time */}
            <p className="mb-3 orange-txt">
              Estimated Delivery time 30-120 mins
            </p>

            {/* Select Delivery Slot */}
            <fieldset className="box fieldset">
              <label htmlFor="country">Select a delivery Slot</label>
              <div>
                <Autocomplete
                  disablePortal
                  size="small"
                  options={deliveryInfoOptions?.data?.map((option: any) => {
                    // Returning an object with both id and value for reference, but we render only the value.
                    return {
                      id: option?.slot_id, // `slot_id` as the unique identifier
                      value:
                        deliveryInfoOptions?.pickup === "Not Available"
                          ? option?.date // Use `date` if pickup is "Not Available"
                          : option?.delivery_slot, // Use `delivery_slot` otherwise
                    };
                  })}
                  // Render only the value of the option (either date or slot)
                  getOptionLabel={(option) => option.value} // Ensure we display the correct value (e.g., date or delivery slot)
                  renderInput={(params) => <TextField {...params} />}
                  id="slot"
                  value={
                    slotValue?.id
                      ? { id: slotValue.id, value: slotValue.value }
                      : null
                  }
                  onChange={(event, newValue) => {
                    setSlotValue({ id: newValue?.id, value: newValue?.value }); // Update the local state with the selected value
                    // Dispatch the selected slot's ID
                    if (newValue) {
                      dispatch(selectedDeliverySlot(newValue.id)); // Dispatching the selected slot's ID
                      dispatch(selectedDeliveryDate(newValue.value));
                    }
                  }} // Update slot value
                />
              </div>
            </fieldset>

            {/* Delivery Address Input */}
            <fieldset className="box fieldset mt-3">
              <label htmlFor="note" style={{ paddingBottom: "1rem" }}>
                Your order will be delivered at the following address
              </label>{" "}
              <CustomInput
                type="text"
                label="Delivery Address"
                name="delivery_address"
                required
                size="small"
                variant="outlined"
                fullWidth
                rows={3}
                value={deliveryAddress}
                readOnly
                // onChange={inputChange} // Handle address input change
              />
            </fieldset>

            {/* Delivery Instructions */}
            <fieldset className="box fieldset mt-3">
              <label htmlFor="country">Select Delivery Instructions</label>
              <div>
                <FormGroup>
                  <FormControlLabel
                    required
                    control={<Checkbox />}
                    label="Avoid Ringing Bell"
                  />
                  <FormControlLabel
                    required
                    control={<Checkbox />}
                    label="Leave at the Door"
                  />
                </FormGroup>
              </div>
            </fieldset>
            <div id="triggerDiv">
              <p>
                <a href="#">
                  <i className="fa fs-18 fa-plus-circle green-icon"></i>{" "}
                  <span>
                    {" "}
                    <AddIcon
                      style={{ color: "green", fontSize: 30 }}
                      onClick={toggleVisibility}
                    />
                  </span>
                  <b>Order for someone else</b>
                </a>
              </p>
            </div>
            {isVisible && (
              <div id="targetDiv" style={{ display: "flex" }}>
                <div className="row">
                  {/* Name Field */}
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Name</span>
                      <div className="select-custom">
                        <CustomInput
                          type="text"
                          label="Enter your name"
                        ></CustomInput>
                      </div>
                    </fieldset>
                  </div>

                  {/* Contact No. Field */}
                  <div className="col-6 ps-0">
                    <fieldset className="box fieldset">
                      <span>Contact No.</span>
                      <div className="select-custom">
                        <CustomInput
                          type="text"
                          label="Enter contact number"
                          // id="contact"
                        ></CustomInput>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <CustomButton
        endIcon={<ArrowForwardIcon />}
        className="mt-3"
        name="Continue"
        onClick={() => onNextClick("pay")}
        disabled={!isInputFilled}
      />
    </div>
  );
};
